import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { makeStyles } from 'react-scale/components/design-system/styles';
import { TraversedTaskerWorkflowStep } from '@scale/shared/taskerWorkflow/TaskerWorkflow';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { WorkflowHook } from '../Sidebar/GuidedWorkflowPanel/useWorkflow';

interface WorkflowStepNodeProps {
  node: TraversedTaskerWorkflowStep;
  state: 'active' | 'sibling' | 'completed' | 'unstarted';
  workflowHook: WorkflowHook;
  workflowStepContainerRef: React.RefObject<HTMLDivElement> | null;
}

const useStyles = makeStyles({
  container: {
    padding: '8px 3px',
    display: 'flex',
    alignItems: 'center',
  },
});

const WorkflowStepNode: React.FC<WorkflowStepNodeProps> = props => {
  const classes = useStyles();

  const handleClick: React.MouseEventHandler = e => {
    e.stopPropagation();
    props.workflowHook.setActiveStepId(props.node.id);
    if (!props.workflowHook.workflowState.isGuidedWorkflowTooltipOpen) {
      props.workflowHook.toggleIsGuidedWorkflowTooltipOpen();
    }
  };

  // consider the first node (root node) as depth 1 and make it the welcome node
  const depth = props.node.depth === 0 ? 1 : Math.min(props.node.depth, 3);
  // Need +1 to deal with depth 0
  const style = {
    fontSize: 30 / Math.pow(1.5, depth),
  };

  let iconColor;
  let icon: IconProp;
  switch (props.state) {
    case 'active':
      iconColor = 'var(--color-RemoBlue)';
      icon = 'circle';
      break;
    case 'completed':
      if (depth === 1) {
        iconColor = '#29CD9C';
        icon = 'check-circle';
      } else {
        iconColor = '#29CD9C';
        icon = 'circle';
      }
      break;
    case 'sibling':
      iconColor = 'var(--color-RemoGray50)';
      icon = 'circle';
      break;
    default:
      iconColor = '#C4C4C4';
      icon = 'circle';
  }

  const toolTipId = 'tool-tip-id' + props.node.id;

  return (
    <div
      className={classes.container}
      style={style}
      onClick={handleClick}
      ref={props.workflowStepContainerRef}
      data-for={toolTipId}
      data-tip={true}
    >
      <FontAwesomeIcon color={iconColor} icon={icon} />
      <ReactTooltip id={toolTipId}>{props.node.name}</ReactTooltip>
    </div>
  );
};

export default WorkflowStepNode;
